import { render, staticRenderFns } from "./AddUpdateFormEmailManager.vue?vue&type=template&id=53824beb&scoped=true"
import script from "./AddUpdateFormEmailManager.vue?vue&type=script&lang=js"
export * from "./AddUpdateFormEmailManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53824beb",
  null
  
)

export default component.exports